import { render } from "./SimpleRichTextBox.vue?vue&type=template&id=560a5787&scoped=true"
import script from "./SimpleRichTextBox.vue?vue&type=script&lang=js"
export * from "./SimpleRichTextBox.vue?vue&type=script&lang=js"

import "./SimpleRichTextBox.vue?vue&type=style&index=0&id=560a5787&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560a5787"]])

export default __exports__